<template>
    <div>
        <div v-if="!selectedFridge">
            Холодильник не выбран
        </div>
        <div v-if="selectedFridge">
            <last-error-block></last-error-block>

            <div>
                <div>
                    <button class="btn btn-success" @click="memoryValues()">
                        Обнулить значения
                    </button>
                    &nbsp;
                    <button class="btn btn-danger" @click="clearMemoryValues()">
                        Сбросить обнуление
                    </button>
                </div>

                <table class="table table-sm">
                    <tr>
                        <th>&nbsp;</th>
                        <th v-for="rack in racks">{{rack}}</th>
                    </tr>

                    <tr v-for="shelf in shelves">
                        <th>{{shelf}}</th>

                        <td v-for="rack in racks" @click="goToCalibrate(shelf, rack)">
                            {{getValue(shelf, rack)}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import fridgeRabbit from "../utils/rabbit/fridge_rabbit";
    import LastErrorBlock from "../components/LastErrorBlock";


    export default {
        name: "TestScalesShelf",
        components: {LastErrorBlock},
        computed: {
            ...mapState('app', [
                'selectedFridge',
            ]),
        },
        methods: {
            ...mapActions('app', {
                setLastError: 'setLastError',
                clearLastError: 'clearLastError',
            }),
            checkScales() {
                this.response = null;
                fridgeRabbit.send('check_scales_shelf');
            },
            onAnswer(data) {
                if(!data) {
                    return;
                }

                if(!data.success) {
                    this.setLastError(data.error);
                } else {
                    this.clearLastError();
                }

                this.response = data;

                if(data.success && data.scales) {
                    this.processScalesData(data.scales);
                }
            },
            sortArray(arr) {
                return arr.sort((a, b) => a - b);
            },
            getShelfRackKey(shelf, rack) {
                if(this.shelves.indexOf(shelf) < 0) {
                    this.shelves.push(shelf);
                    this.shelves = this.sortArray(this.shelves);
                }

                if(this.racks.indexOf(rack) < 0) {
                    this.racks.push(rack);
                    this.racks = this.sortArray(this.racks);
                }

                return `${shelf}-${rack}`;
            },
            processScalesData(scalesArray) {
                this.values = {};

                for(let i = 0; i < scalesArray.length; i++) {
                    const scales = scalesArray[i];
                    const key = this.getShelfRackKey(scales.shelf, scales.rack);

                    this.values[key] = scales.weight;
                }
            },
            getValue(shelf, rack) {
                const key = this.getShelfRackKey(shelf, rack);
                let value = this.values[key];

                if(this.memory !== null) {
                    value -= this.memory[key] || 0;
                }

                return Math.round(value * 1000) / 1000;
            },
            memoryValues() {
                this.memory = {};

                Object.keys(this.values).forEach(key => {
                    this.memory[key] = this.values[key];
                });
            },
            clearMemoryValues() {
                this.memory = null;
            },
            goToCalibrate(shelf, rack) {
                this.$router.push({name: 'calibrate_scales_shelf', params: {shelf, rack}});
            },
        },
        data() {
            return {
                response: null,

                shelves: [],
                racks: [],
                values: {},

                memory: null,
            };
        },
        async mounted() {
            await fridgeRabbit.listen(this.onAnswer);
            this.checkScales();
        },
        destroyed() {
            fridgeRabbit.clear();
            this.clearLastError();
        },
    }
</script>

<style scoped>

</style>
